export default __webpack_public_path__ + "static/media/CoinNavDeactive.82fcdd28.svg";